import React, {
    useState,
    useEffect
} from "react";

import {
    COLOR_GRAY_BANNER_BACKGROUND
} from "../../constants/general-constants";

export default function SurveyProgress({

    onHourComplete

}) {

    const [progress, setProgress] =
        useState(0);

    const [timeRemaining, setTimeRemaining] =
        useState("");

    const [flashRed, setFlashRed] =
        useState(false);

    const MAIN_COLOR =
        "#5a9bd6";

    useEffect(function () {

        function updateProgress() {

            const now =
                new Date();

           

            /******************************************************************
             * LIVE MODE
             ******************************************************************/

            const start =
                new Date(

                    now.getFullYear(),
                    now.getMonth(),
                    now.getDate(),
                    now.getHours(),
                    0,
                    0,
                    0
                );

            const end =
                new Date(

                    now.getFullYear(),
                    now.getMonth(),
                    now.getDate(),
                    now.getHours(),
                    59,
                    59,
                    999
                );

            const total =
                end.getTime() - start.getTime();

            const elapsed =
                now.getTime() - start.getTime();

            const remaining =
                Math.max(
                    0,
                    end.getTime() - now.getTime()
                );

            const pct =
                Math.max(
                    0,
                    Math.min(1, elapsed / total)
                );

            setProgress(pct);

            const secs =
                Math.floor(remaining / 1000);

            const mins =
                Math.floor(secs / 60);

            const secPart =
                secs % 60;

            const formatted =
                mins > 0
                    ? `${mins}m ${secPart}s`
                    : `${secPart}s`;

            setTimeRemaining(formatted);

            if (remaining <= 5 * 60 * 1000) {

                setFlashRed((prev) => !prev);
            }
            else {

                setFlashRed(false);
            }
        }

        updateProgress();

        const interval =
            setInterval(
                updateProgress,
                1000
            );

        return function () {

            clearInterval(interval);
        };

    }, [
       
    ]);

    /**************************************************************************
     * CONTAINER
     *************************************************************************/

    const thisContainer = {

        display: "flex",

        minWidth: 0,

        width: "calc(100% - 40px)",

        paddingLeft: "20px",
        paddingRight: "20px",

        background:
            "linear-gradient(180deg,#1e293b 0%, #0f172a 100%)",

        justifyContent: "space-between",

        alignItems: "center",

        borderBottom:
            "1px solid rgba(255,255,255,0.05)"
    };

    /**************************************************************************
     * TIME LABEL
     *************************************************************************/

    const timeRemainingContainer = {

        display: "flex",

        marginLeft: "14px",

		color:
		    flashRed
		        ? "#ff6666"
		        : "#7dd3fc",

        fontSize: "11px",

        fontWeight: "700",

        minWidth: "70px",

        justifyContent: "flex-end",

        letterSpacing: "0.5px",

		textShadow:
		    flashRed
		        ? "0 0 10px rgba(255,80,80,0.75)"
		        : "0 0 10px rgba(125,211,252,0.35)"
    };

    /**************************************************************************
     * BAR COLOUR
     *************************************************************************/

    
	const barColor =
	    flashRed
	        ? "linear-gradient(90deg,#ff6b6b 0%, #ef4444 100%)"
	        : "linear-gradient(90deg,#5a9bd6 0%, #60a5fa 45%, #22d3ee 100%)";

    return (

        <div style={thisContainer}>

            {/* PROGRESS TRACK */}
            <div
                style={{

                    background:
                        "rgba(255,255,255,0.08)",

                    borderRadius: "999px",

                    height: "10px",

                    flex: 1,

                    margin: "10px 0",

                    overflow: "hidden",

                    boxShadow:
                        "inset 0 1px 3px rgba(0,0,0,0.45)"
                }}
            >

                {/* PROGRESS BAR */}
                <div
                    style={{

                        background: barColor,

                        width:
                            `${progress * 100}%`,

                        height: "100%",

                        transition:
                            "width 0.5s linear, background 0.3s ease",

                        borderRadius: "999px",

						boxShadow:
						    flashRed
						        ? "0 0 14px rgba(239,68,68,0.65)"
						        : "0 0 12px rgba(90,155,214,0.45)"
                    }}
                />

            </div>

            {/* TIME REMAINING */}
            <div style={timeRemainingContainer}>

                {
                   timeRemaining
                }

            </div>

        </div>
    );
}